"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const { btnSecondaryDefault, btnSecondaryHover, btnDisabled, btnSecondaryActive, btnSecondaryDisabled, btnGhostDefault, transparent, btnGhostHover, btnGhostActive, primary, secondary, grey, white, btnDefault, btnTertiary, btnHover, btnActive, } = styles_scss_1.default;
const { slimButtonHeight, inputHeight, sFont, xxsFont, spacer, smallestSpacer } = styles_scss_1.default;
function getVariantColors(variant) {
    if (variant === 'primary') {
        return { colorDefault: white, colorDisabled: white };
    }
    if (variant === 'secondary') {
        return {
            colorDefault: btnDefault,
            colorDisabled: grey,
        };
    }
    if (variant === 'ghost') {
        return {
            colorDefault: btnDefault,
            colorDisabled: btnDisabled,
        };
    }
    return null;
}
const Styles = {
    toggle: (toggleIcon, variant, disabled) => core_1.css `
    display: flex;
    align-items: center;
    height: 100%;
    align-self: flex-end;
    justify-content: flex-end;
    align-items: center;
    margin-left: ${styles_scss_1.default.xs};
    border-left: 1px solid ${!disabled ? getVariantColors(variant).colorDefault : getVariantColors(variant).colorDisabled};
    width: 30px;
    
    .toggle-icon {
      background-image: url('${!disabled ? toggleIcon.default : toggleIcon.disabled}');
      background-size: cover;
      height: 23px;
      width: 23px;
      background-repeat: no-repeat;
    }`,
    // eslint-disable-next-line max-lines-per-function
    button: (props) => core_1.css `
      display: flex;
      font-size: ${sFont};
      padding: 5px ${spacer} 5px;
      height: ${inputHeight};
      ${props.slim &&
        `
        height: ${slimButtonHeight};
        font-size: ${xxsFont};
        padding: 0 ${smallestSpacer};
      `}
${props.variant === 'primary' &&
        `
        background-color: ${btnDefault};
        color: ${white};
        :hover {
          background-color: ${btnHover};
        }
        :active {
          background-color: ${btnActive};
        }
      `}
${props.variant === 'secondary' &&
        `
        background-color: ${btnSecondaryDefault};
        color: ${white};
        :hover {
          background-color: ${btnSecondaryHover};
        }
        :active {
          background-color: ${btnSecondaryActive};
        }
      `}
${props.disabled &&
        props.variant === 'primary' &&
        `
        background-color: ${btnDisabled};
        cursor: not-allowed;
        :hover {
          background-color: ${btnDisabled};
        }
        :active {
          background-color: ${btnDisabled};
        }
      `}
${props.disabled &&
        props.variant === 'secondary' &&
        `
        color: ${grey};
        background-color: ${btnSecondaryDisabled};
        cursor: not-allowed;
        :hover {
          background-color: ${btnSecondaryDisabled};
        }
        :active {
          background-color: ${btnSecondaryDisabled};
        }
      `}
${props.variant === 'ghost' &&
        `
        background-color: ${btnGhostDefault};
        color: ${btnDefault};
        border: 1px solid ${btnDefault};
        :hover {
          background-color: ${btnGhostHover};
        }
        :active {
          background-color: ${btnGhostActive};
          color: ${btnActive};
          border: 1px solid ${btnActive};
        }
      `}
${props.disabled &&
        props.variant === 'ghost' &&
        `
        background-color: ${btnGhostDefault};
        color: ${btnDisabled};
        border: 1px solid ${btnDisabled};
        cursor: not-allowed;
        :hover {
          background-color: ${btnGhostDefault};
        }
      `}
      ${props.variant === 'tertiary-ghost' &&
        `
            background-color: ${btnGhostDefault};
            color: ${btnTertiary};
            border: 1px solid ${grey};
            :hover {
              background-color: ${btnGhostHover};
            }
            :active {
              background-color: ${btnGhostActive};
              color: ${btnActive};
              border: 1px solid ${btnActive};
            }
          `}
    ${props.disabled &&
        props.variant === 'tertiary-ghost' &&
        `
            background-color: ${btnGhostDefault};
            color: ${btnDisabled};
            border: 1px solid ${btnDisabled};
            cursor: not-allowed;
            :hover {
              background-color: ${btnGhostDefault};
            }
          `}
${props.variant === 'secondary-ghost' &&
        `
            background-color: ${white};
            color: ${secondary};
            border: 1px solid ${secondary};
            :hover {
              background-color: ${secondary};
              color: ${white};
            }
            :active {
              background-color: ${secondary};
              color: ${white};
              border: 1px solid ${secondary};
            }
          `}

          ${props.variant === 'transparent' &&
        `     padding-left: 0px;
                padding-right: 0px;
                background-color: ${transparent};
                color: ${btnTertiary};
                :active {
                  color: ${btnDefault};
                }
              `}
        ${props.disabled &&
        props.variant === 'transparent' &&
        `
                cursor: not-allowed;   
              `}
${props.imgUrls &&
        `
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        :active {
          .icon {
            background-image: ${`url(${props.imgUrls.selected || props.imgUrls.default})`};
            background-repeat: no-repeat;
          }
        }
      `}
      ${props.isFilter && props.filterCount &&
        `  
            background-color: ${transparent};
            color: ${primary};
            border: 1px solid ${primary};
            
          `}
      .icon {
        background-image: ${props.imgUrls ? `url(${props.imgUrls.default})` : 'none'};
        height: 17px;
        width: 17px;
        display: inline-block;
        background-size: cover;
        background-repeat: no-repeat;
        margin: 5px 5px 0 0px;
        vertical-align: bottom;
      }
    `,
};
exports.default = Styles;
